<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Error</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div>
      Please navigate to
      <a class="ml-2 ml-auto" [routerLink]="['/user/project-configuration']" [queryParams]="{ id: testcaseDetails.project.id, showJiraConfiguration : true, default: false }" target="_blank">Project Configuration</a>
      page and update the necessary details.
    </div>
    <table class="table table-bordered">
        <thead>
          <tr class="font-bold">
            <th>Parameter Name</th>
            <th>Reason</th>
          </tr>
        </thead>
        <tr *ngFor="let item of errorsArray">
          <td>{{item.key}}</td>
          <td>{{item.value}}</td>
        </tr>
      </table>
  </div>
